module.exports = __webpack_public_path__ + "static/media/sl_marker_police_default.9c95baa2.svg";